import { Link } from "react-router-dom";

export default function Breadcrumbs({ items = [] }) {
  return (
    <nav data-testid="breadcrumbs" aria-label="breadcrumb" className="flex flex-wrap items-center gap-2 font-oswald text-[11px] uppercase tracking-[0.16em] text-neutral-500">
      {items.map((item, i) => {
        const last = i === items.length - 1;
        return (
          <span key={i} className="flex items-center gap-2">
            {item.to && !last ? (
              <Link to={item.to} className="transition-colors hover:text-gold">{item.label}</Link>
            ) : (
              <span className={last ? "text-gold" : ""}>{item.label}</span>
            )}
            {!last && <span className="text-neutral-700">/</span>}
          </span>
        );
      })}
    </nav>
  );
}
